/* eslint-disable no-param-reassign */
import type { AugmentedTextTrack } from 'video.js';

type Payload = {
  textTracks: AugmentedTextTrack[];
  line?: LineAndPositionSetting;
  position?: LineAndPositionSetting;
  align?: AlignSetting;
};

export function applySubtitlePosition({ textTracks, line = 100, position = 50, align = 'center' }: Payload) {
  textTracks.forEach((track) => {
    if (track.cues) {
      Array.from(track.cues).forEach((cue) => {
        if (cue) {
          cue.position = position;
          cue.line = line;
          cue.align = align;
        }
      });
    }
  });
}
